import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AccountSummaryDetailsComponent } from './account-summary-details/account-summary-details.component'
import { SpinnerModule } from '@spartacus/storefront'
import { MaterialModule } from '../shared/material.module'
import { SharedModule } from '../shared/shared.module'
import { CmsConfig, provideDefaultConfig } from '@spartacus/core'
import { FormsModule } from '@angular/forms'
import { UserPermissionsGuard } from '../../guards/user-permissions.guard'

@NgModule({
  declarations: [AccountSummaryDetailsComponent],
  imports: [CommonModule, SpinnerModule, MaterialModule, SharedModule, FormsModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        AccountSummaryComponent: {
          component: AccountSummaryDetailsComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class AccountSummaryModule {}
